module.exports = __webpack_public_path__ + "media/views/about/images/search-9929d508a97d865607761dceb5186743.svg";